function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from 'react';
import { withMedia } from 'react-media-query-hoc';
import { PhoneIcon } from '@domain-group/fe-co-icon';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import { Button } from '../button';
import noop from '../../utils/noop';
import * as styles from './call-button.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var CallButton = _ref => {
  var media = _ref.media,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? undefined : _ref$className,
    phone = _ref.phone,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? noop : _ref$onClick,
    _ref$showIcon = _ref.showIcon,
    showIcon = _ref$showIcon === void 0 ? {
      beforeClick: true,
      afterClick: false
    } : _ref$showIcon,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Call' : _ref$label,
    _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'outline' : _ref$appearance;
  var mobile = media.mobile;
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isClicked = _useState2[0],
    setClicked = _useState2[1];
  var handleClick = args => {
    if (!isClicked) {
      if (mobile && typeof window !== 'undefined') {
        setTimeout(() => {
          window.location.href = "tel:".concat(phone.replace(/\s/, ''));
        }, 100);
      } else {
        setClicked(true);
      }
      sendEvent('call-reveal');
      onClick(args);
    }
  };
  var getIcon = () => {
    if (!showIcon.beforeClick || isClicked && !showIcon.afterClick) {
      return undefined;
    }
    return ___EmotionJSX(PhoneIcon, null);
  };
  return ___EmotionJSX(Button, {
    appearance: appearance,
    css: styles.callButton,
    className: className,
    icon: getIcon(),
    onClick: handleClick
  }, isClicked ? phone : label);
};
export default withMedia(CallButton);
export { CallButton as BaseCallButton };